(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  $('#toggle_grid').on('click',function(e){
  	
    console.log('ok');
     $('#toggle_list').removeClass('activeclass');
    $('#toggle_grid').addClass('activeclass');
    
   $('.grid-view1').css({"display":"none"});
    $('.list-view').css({"display":"block"});
  
  });
  $('#toggle_list').on('click',function(e){
    
    $('#toggle_grid').removeClass('activeclass');
  	 $('#toggle_list').addClass('activeclass');
    
    $('.grid-view1').css({"display":"block"});
    $('.list-view').css({"display":"none"});
  
  });
  $('.loadmore').on('click',function(e){
  	
    
    $('.hidediv').removeClass('hidediv');
	 $('.loadmore').addClass('hidediv');
    
    
    
  });
 $('.acc1').hide();
        
  
	$('#b1').on('click', function() {
		$('.1').slideToggle('fast');
	});
	$('#b2').on('click', function() {
		$('.2').slideToggle('fast');
	});
	$('#b3').on('click', function() {
		$('.3').slideToggle('fast');
	});
      $('#b4').on('click', function() {
		$('.4').slideToggle('fast');
	});
	  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

$('.mobile-nav--close').click(function(e){

$('.js-menu--is-open').css({"transform":"translate3d(0, -100%, 0)"});
console.log('close');	
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

  $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[id='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(1);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[id='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
        }
    });

    $('#parentHorizontalTab').easyResponsiveTabs({
            type: 'default', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function(event) { // Callback function if tab is switched
                var $tab = $(this);
                var $info = $('#nested-tabInfo');
                var $name = $('span', $info);
                $name.text($tab.text());
                $info.show();
            }
        });

$('.bxslidermob').bxSlider({
  minSlides: 3,
  maxSlides: 3,
  slideWidth: 100,
  slideMargin: 15,
  pager:false	
});


  } catch(e) { console.error(e); }
})();

})();
